<template>
  <transition name="cookie-fade">
    <div
      v-if="show"
      v-cloak
      class="cookie-popup"
      role="dialog"
      aria-live="polite"
      aria-label="Угода про використання файлів cookie"
    >
      <div class="cookie-popup__description">
        <p>
          Ми використовуємо файли cookie, щоб покращити ваш досвід користування
          сайтом. Продовжуючи перегляд, ви погоджуєтесь з
          <router-link to="/cookie-policy">
            Політикою конфіденційності</router-link
          >.
        </p>
      </div>

      <button
        class="cookie-popup__btn btn-filter"
        @click.prevent="acceptCookies"
      >
        Добре
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookiePopup',
  data() {
    return {
      show: false,
      showDelay: 1500
    };
  },
  mounted() {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setTimeout(() => {
        this.show = true;

        this.$nextTick(() => {
          const confirmBtn = this.$el.querySelector('button');
          if (confirmBtn) {
            confirmBtn.focus();
          }
        });
      }, this.showDelay);
    }
  },
  methods: {
    acceptCookies() {
      localStorage.setItem('cookie_consent', 'accepted');
      this.show = false;

      if (this.$route.name === 'cookie-policy') {
        this.$router.push({
          name: 'home'
        });
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.cookie-popup
  position: fixed
  z-index: 9999
  bottom: 1rem
  left: 1rem
  right: 1rem
  display: flex
  flex-direction: column
  gap: 0.75rem
  margin: 0 auto
  border-radius: 0.375rem
  max-width: 45rem
  padding: 1rem 1.5rem
  background-color: var(--color-moonless-mystery)
  box-shadow: 0 3px 9px rgba(0, 0, 0, .5)
  color: var(--color-gray-chain-gang)
  font-size: 0.875rem
  font-weight: 300
  line-height: 1.42

  &__description
    p
      margin: 0

  &__btn
    align-self: flex-end

.cookie-fade-enter-active,
.cookie-fade-leave-active
  transition: transform 0.35s ease, opacity 0.35s ease

.cookie-fade-enter,
.cookie-fade-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
